import { Content, Option, Root, Separator, Trigger } from "./Select";

export { default as DeprecatedSelectOption } from "./_deprecated/DeprecatedOption";
export { default as DeprecatedSelect } from "./_deprecated/DeprecatedSelect";
export { SelectTrigger } from "./SelectTrigger";
export { useSelectState } from "./use-select-state";
export const Select = { Root, Trigger, Content, Option, Separator };
export * from "./types";
export { useSelectItems } from "./use-select-items";
